var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { name: "delete-group", width: 0 },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c(
        "div",
        { staticClass: "modal modal__sphir_Online_Access_Agreement show" },
        [
          _c(
            "section",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.hide,
                  expression: "hide"
                }
              ]
            },
            [
              _c("a", { staticClass: "modal__close" }, [
                _c("i", { staticClass: "icon-close", on: { click: _vm.hide } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _vm._v("\n                Delete a Sphir?\n            ")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                Are you sure you want to delete this Sphir?"
                ),
                _c("br"),
                _vm._v(
                  "\n                This action can't be undone.\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn__round btn__bordered",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.hide }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn__round",
                  staticStyle: { color: "white" },
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.handleDeleteGroup }
                },
                [_vm._v("Delete")]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }